// extracted by mini-css-extract-plugin
export default {"drawDialog":"drawDialog_drawDialog__NNZ5T","accept":"drawDialog_accept__8dy6Z","reject":"drawDialog_reject__-Qys5"};